// Browser-only config accessors. No dotenv, no fs. Read from import.meta.env only.

export type BrowserEnv = {
  VITE_CONVEX_URL?: string
  VITE_CLERK_PUBLISHABLE_KEY?: string
}

function readBrowserEnv<K extends keyof BrowserEnv>(name: K): string | undefined {
  const viteEnv = (import.meta as any)?.env as Record<string, string | undefined> | undefined
  return viteEnv?.[name]
}

export function getConvexUrlOptional(explicit?: string): string | undefined {
  return explicit || readBrowserEnv('VITE_CONVEX_URL')
}

export function getClerkPublishableKeyOptional(explicit?: string): string | undefined {
  return explicit || readBrowserEnv('VITE_CLERK_PUBLISHABLE_KEY')
}


